import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/ui/page";
import { fmtDateTime } from "@/lib/format";

const ACTION_TONE = {
  LOGIN: "text-emerald-600", LOGOUT: "text-slate-500", CREATE_EMPLOYEE: "text-teal-600",
  DISABLE_EMPLOYEE: "text-red-600", REACTIVATE_EMPLOYEE: "text-emerald-600", UPDATE_POLICY: "text-amber-600",
  BREAK_START: "text-amber-600", BREAK_END: "text-slate-600", EXPORT: "text-blue-600", RESET_PASSWORD: "text-red-600",
};

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  const filtered = logs.filter((l) => !q || `${l.user_name} ${l.action} ${l.description}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Immutable record of administrative actions" testId="audit-header">
        <input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search logs…" className="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#08A7A0]" />
      </PageHeader>
      <Card testId="audit-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50"><tr className="text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3">Timestamp</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Role</th>
              <th className="px-4 py-3">Action</th><th className="px-4 py-3">Description</th><th className="px-4 py-3">Target</th><th className="px-4 py-3">IP</th></tr></thead>
            <tbody>
              {filtered.length === 0 && <tr><td colSpan={7}><Empty /></td></tr>}
              {filtered.map((l) => (
                <tr key={l.id} data-testid={`audit-row-${l.id}`} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3 font-mono text-xs text-slate-500">{fmtDateTime(l.timestamp)}</td>
                  <td className="px-4 py-3 font-semibold text-[#0B1F33]">{l.user_name}</td>
                  <td className="px-4 py-3 text-xs uppercase text-slate-500">{l.role}</td>
                  <td className={`px-4 py-3 font-mono text-xs font-bold ${ACTION_TONE[l.action] || "text-slate-600"}`}>{l.action}</td>
                  <td className="px-4 py-3 text-slate-600">{l.description}</td>
                  <td className="px-4 py-3 text-xs text-slate-400">{l.target_employee || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-400">{l.ip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
